module.exports = __webpack_public_path__ + "img/logo-on-color.a73a98b.png";